export default __webpack_public_path__ + "static/media/logo_dark.b120afd5.svg";